<terra-main-nav [showNav]="false" [showAccountActions]="false" />

<section class="container">
  <div class="inner-width">
    <div class="border-bottom">
      <div *ngIf="unsubscribeFromMarketingEmails; else template">
        <div *ngIf="unsubscribeSuccessful" class="info-message">You have been successfully unsubscribed</div>

        <h1>Subscribe again?</h1>
        <p class="description">By clicking subscribe you will receive emails from {{ agentCompanyName }} through Covercy platform.</p>
      </div>

      <ng-template #template>
        <div *ngIf="subscribeSuccessful" class="info-message">You have been successfully subscribed</div>

        <h1>Do you really want to unsubscribe?</h1>
        <p class="description">
          By clicking unsubscribe you will no longer receive emails from {{ agentCompanyName }} <br />
          through Covercy platform.
        </p>
      </ng-template>
    </div>

    <button type="button" (click)="unsubscribe()" mat-flat-button class="tall-button" color="primary" [disabled]="isLoading">
      {{ actionName }}
    </button>

    <terra-loader [centerToParent]="true" *ngIf="isLoading"></terra-loader>
  </div>
</section>
